import { gql } from '@apollo/client'

const UPDATE_USER_SETTINGS_MUTATION = gql`
  mutation updateUserSettingsMutation(
    $userId: ID!
    $settings: UserSettingsInput!
  ) {
    updateUserSettings(userId: $userId, settings: $settings) {
      pageSize
    }
  }
`

export default UPDATE_USER_SETTINGS_MUTATION
